import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { UserMenuItems } from './user-menu';
import { environment } from '../../../environments/environment';
import { map, shareReplay } from 'rxjs/operators';
import { Utility } from '../utility';
import { HttpClient } from '@angular/common/http';
import { HttpClientHelper } from '../http-helper';
import { ApiUrlHelper } from 'app/_service/api-url-helper';

@Injectable()
export class MenuService {
    isAdult = environment.cinema === 2;
    menuItems: Array<any> = [];
    topNavItems: Array<any> = [];

    // 午夜主页导航喜爱 由后端获得
    private _adultMenuService = new BehaviorSubject<any>({});
    adultMenuSource$ = this._adultMenuService.asObservable();

    constructor(
        private _httpClient: HttpClient,
        private _utility: Utility,
        private _httpClienthelper: HttpClientHelper,
        private _apiUrlHelper: ApiUrlHelper,
    ) {

    }
    private _mainmenuCached = null;
    private getJson() {
        if(this._mainmenuCached == null)
        {
            this._mainmenuCached = this._httpClient.get(this._utility.getAbsUrl(`./assets/menu/mainmenu_fix${this.isAdult ? "_0_2" : ""}.json?v=4`))
            .pipe(shareReplay());
        }
        return this._mainmenuCached;
    }

    public getMainMenu() {
        if (this.menuItems.length > 0) {
            return of(this.menuItems);
        }
        return this.getJson().pipe(map(res => {
            this.menuItems = <Array<any>>res["main"];
            if (this._utility.getSiteConfig.hidecinema == 0 && environment.cinema == 1) {
                this.menuItems.push({
                    title: '午夜版',
                    routerLink: 'https://www.wyav.tv/',
                    selected: false,
                    expanded: false,
                    seprator: false,
                    externalLink: true,
                    cid: null,
                    submenu: [],
                    slug: ''
                })
            }
            return this.menuItems;
        }))
    }

    public getUserMenu() {
        return (UserMenuItems);
    }

    private getTopNavJson() {
        return this.getJson().pipe(map(res => {
            return <Array<any>>res["top"];
        }))// this._httpClient.get(this._utility.getAbsUrl(`./assets/menu/mainmenu_top_nav.json?v=1`));
    }

    public getTopNavButton() {
        if (this.topNavItems.length > 0) {
            return of(this.topNavItems);
        }
        return this.getTopNavJson().pipe(map(res => {
            this.topNavItems = <Array<any>>res;
            return this.topNavItems;
        }))
    }

    private filterSubMenu(cid) {
        return this.menuItems.filter(p => p.submenu.findIndex(d => !!d && !!d.params && d.params.cid == cid) > -1);
    }
    private filterCID(cid) {
        return this.menuItems.filter(p => !!p && !!p.params && p.params.cid == cid);
    }
    private filterSubMenuTitle(title) {
        return this.menuItems.filter(p => p.submenu.filter(d => d.title == title));
    }
    public getParentMenuItemByCid(cid) {
        const res = this.filterSubMenu(cid);// this.menuItems.filter(p=>p.submenu.filter(d=>d.params.cid == cid));// _.filter(this.menuItems, { submenu: [{ params: { cid: cid } }] });
        return res.length ? res[0] : {};
    }

    public getMenuItemByCid(cid) {
        if (!cid) {
            return [];
        }
        let res = this.filterCID(cid);// _.filter(this.menuItems, { params: { cid: cid } });

        //console.log(this.menuItems,cid);
        if (res.length) {
            return res[0];
        } else {
            res = this.filterSubMenu(cid);//_.filter(this.menuItems, { submenu: [{ params: { cid: cid } }] });
            //console.log(cid,res.length,res[0]);
            if (res.length) {
                return res[0];
            }
        }
        return [];
    }

    public getMenuItemByTitle(title) {
        let res = this.menuItems.filter(item => item.title === title);
        if (res.length) {
            return res[0];
        } else {
            res = this.filterSubMenuTitle(title); //_.filter(this.menuItems, { submenu: [{ title: title }] });
            if (res.length) {
                return res[0];
            }
        }
        return;
    }

    public getMenuItemBySlug(slug) {
        const res = this.menuItems.filter(item => item.slug === slug);
        if (res.length) {
            return res[0];
        }
        return;
    }

    public getSubitemsByCid(cid) {
        const res = this.filterSubMenu(cid);//_.filter(this.menuItems, { params: { cid: cid } });
        if (res.length) {
            return res[0].submenu;
        }
        return [];
    }

    // public updateAdultMenu() {
    //     // 午夜主页导航喜爱 由后端获得
    //     this.getAdultMenu().subscribe(r => {
    //         this._adultMenuService.next(r);
    //     });
    // }

    // getAdultMenu(): any {
    //     const apiURL = this._apiUrlHelper.urlBuilder('get-adult-types', {});
    //     return this._httpClienthelper.get(apiURL)
    //     .pipe(map(l => {
    //             return l[0];
    //         }));
    // }

    public discoveryCateItems: Array<any> = [];
    public getDiscoveryMenu() {
        const apiURL = this._apiUrlHelper.urlBuilder(
            'get-all-label',
            {}
        );
        return this._httpClienthelper.post(apiURL, '', null).pipe(map(res => {
            // 新发现首页 分类导航栏
            // let discoveryCates;
            if (res.length > 0) {
                this.discoveryCateItems = res.map((r: any) => {
                    return {
                        title: r.parentLabel,
                        routerLink: '/discovery/list',
                        selected: false,
                        expanded: false,
                        seprator: false,
                        externalLink: false,
                        params: { tag: r.parentLabel },
                        submenu: r.subLabels.length > 0 ? r.subLabels.map(p => {
                            return {
                                title: p,
                                routerLink: '/discovery/list',
                                selected: false,
                                expanded: false,
                                seprator: false,
                                externalLink: false,
                                params: { tag: r.parentLabel, label: p },
                            }
                        }) : [],
                        slug: r.parentLabel,
                    }
                });
            } else {
                this.discoveryCateItems = [];
            }
            return this.discoveryCateItems;
        }));
    }

}
